import {
  Globe2, Ship, PackageCheck, SearchCheck, FlaskConical, Warehouse,
  FileText, Landmark, Target, Workflow, Truck, ShieldCheck, Headset,
  Network, GraduationCap, BadgeCheck, MessagesSquare, Layers, Handshake,
  Sofa, TreePine, CookingPot, Wheat, ShoppingBasket,
} from "lucide-react";

const MAP = {
  Globe2, Ship, PackageCheck, SearchCheck, FlaskConical, Warehouse,
  FileText, Landmark, Target, Workflow, Truck, ShieldCheck, Headset,
  Network, GraduationCap, BadgeCheck, MessagesSquare, Layers, Handshake,
  Sofa, TreePine, CookingPot, Wheat, ShoppingBasket,
};

export const Icon = ({ name, className = "", strokeWidth = 1.6 }) => {
  const Cmp = MAP[name] || Globe2;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};

export default Icon;
